// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyChO-fWVW_-AWzbJwyszinDNfin0X1GX24",
  authDomain: "electrobazardistribuciones.firebaseapp.com",
  projectId: "electrobazardistribuciones",
  storageBucket: "electrobazardistribuciones.appspot.com",
  messagingSenderId: "398017201246",
  appId: "1:398017201246:web:d5375c965bf8cb4176a0cf"
};

firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();